<template>
  <modal-template size="large"
                  :title="$t('nominatives.datosDeLosAsistentes')"
                  @close="$root.$emit('closeNominatives')">
    <div class="nominatives-modal container-nominatives">
      <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="manageTickets">
          <b-row>
            <b-col cols="12"
                   md="6">
              <p class="help-text">{{ $t('nominatives.tusEntradasSonNominativasRecuerdaQue') }}</p>
              <div v-for="(item, index) in selected"
                   :key="item.id">
                <p v-if="item.personal || item.personal_id"
                   class="ticket-title">{{ item.title }}</p>
                <div v-for="(itemAux, indexAux) in item.tickets"
                     :key="indexAux">
                  <validation-provider v-if="item.personal"
                                       v-slot="{ errors }"
                                       rules="required">
                    <input v-model="form.names[index][indexAux]"
                           :placeholder="$t('nominatives.nombreYApellidos')"
                           :name="`assistant${indexAux}`"
                           :class="{'error': errors[0]}"
                           type="text"
                           required
                           @input="nameTicket(form.names[index][indexAux], item, indexAux)">
                  </validation-provider>
                  <validation-provider v-if="item.personal_id"
                                       v-slot="{ errors }"
                                       rules="required">
                    <input v-model="form.idcards[index][indexAux]"
                           :placeholder="$t('nominatives.DNI')"
                           type="text"
                           :class="{'error': errors[0]}"
                           :name="`DNI${indexAux}`"
                           required
                           @input="idcardTicket(form.idcards[index][indexAux], item, indexAux)">
                  </validation-provider>
                </div>
              </div>
            </b-col>
            <b-col cols="12"
                   md="6">
              <div id="nominativesDetail"
                   class="selected">
                <p class="detail">{{ $t('nominatives.detalleDeCompra') }}</p>
                <div class="container-info">
                  <div v-for="ticket in selected"
                       :key="ticket.id">
                    <p class="tAl info">{{ ticket.quantity }}x {{ ticket.title }}</p>
                    <p class="tAr info">{{ $n(ticket.price * ticket.quantity, { key: 'currency', currency: ticket.currency }) }}</p>
                  </div>
                  <p class="tAl info">{{ $t('nominatives.gastosDeGestion') }}</p>
                  <p class="tAr info">{{ $n(taxes, { key: 'currency', currency: currency }) }}</p>
                  <p class="tAl total">{{ $t('nominatives.total') }}</p>
                  <p class="tAr total">{{ $n(total, { key: 'currency', currency: currency }) }}</p>
                </div>
                <button id="purchase-nominative"
                        :disabled="invalid"
                        :class="{'opacity': !invalid, 'transparent': invalid}"
                        class="btn purchase">{{ $t('nominatives.comprar') }}</button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </modal-template>
</template>

<script>
import { purchase } from '@/plugins/mixins/purchase.js'
import { userStatus } from '@/plugins/mixins/userStatus.js'
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  mixins: [purchase, userStatus],
  data() {
    return {
      form: {
        names: [],
        idcards: []
      },
      header: undefined,
      nominativesDetail: undefined
    }
  },
  computed: {
    selected() {
      return this.$store.state.tickets.selected
    },
    total() {
      return this.$store.state.tickets.total
    },
    taxes() {
      return this.$store.state.tickets.taxes
    },
    currency() {
      return this.$store.state.tickets.currency
    }
  },
  created() {
    this.$store.state.tickets.selected.forEach((item, index) => {
      this.form.names[index] = []
      var array = Array.from(Array(item.quantity), (x, indexAux) => indexAux)
      if (item.personal) {
        array.forEach((itemAux, indexAux) => {
          this.form.names[index][indexAux] = ''
        })
      }
      this.form.idcards[index] = []
      if (item.personal_id) {
        array.forEach((itemAux, indexAux) => {
          this.form.idcards[index][indexAux] = ''
        })
      }
    })
  },
  mounted() {
    this.header = document.getElementById('header')
    this.nominativesDetail = document.getElementById('nominativesDetail')
    window.addEventListener('scroll', this.handleScrollNominativesDetail)
    this.handleScrollNominativesDetail()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollNominativesDetail)
    this.header = undefined
    this.nominativesDetail = undefined
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone||iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
    handleScrollNominativesDetail() {
      var deviceType = this.isMobile()
      if (
        this.header &&
        deviceType === 'pc' &&
        this.nominativesDetail &&
        window.scrollY >
          this.nominativesDetail.parentNode.offsetTop -
            this.header.offsetHeight -
            20
      ) {
        this.nominativesDetail.classList.add('isAffixed')
      } else if (this.nominativesDetail && this.nominativesDetail.classList) {
        this.nominativesDetail.classList.remove('isAffixed')
      }
    },
    manageTickets() {
      var tickets = []
      this.$store.state.tickets.selected.forEach((item, index) => {
        tickets = tickets.concat(item.tickets)
      })
      this.$store.dispatch('purchase/setTickets', { tickets: tickets })
      if (
        this.$store.state.initial.detail.user_id ||
        this.$store.state.user.detail.id
      ) {
        var userStatus = this.checkUserStatus()
        if (userStatus === 'name' || userStatus === 'profile') {
          this.$root.$emit('openBasicInfoPurchase')
        } else {
          this.$root.$emit('closeNominatives')
          this.createPurchase()
        }
      } else {
        this.$root.$emit('closeNominatives')
        if (process.env.VUE_APP_BUYER === 'false') {
          this.$root.$emit('openSignupPurchase')
        } else {
          this.$root.$emit('openBuyerInfo')
        }
      }
    },
    nameTicket(event, ticket, index) {
      this.$store.dispatch('tickets/fill', {
        ticket: ticket,
        name: event,
        index: index
      })
    },
    idcardTicket(event, ticket, index) {
      this.$store.dispatch('tickets/fill', {
        ticket: ticket,
        id_card: event,
        index: index
      })
    }
  }
}
</script>
